import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInterestSessionModel } from '../../hooks/useInterestSessionModel';
import InterestLegacySwipeSession from './InterestLegacySwipeSession';
import InterestTriGroupSwipeSession from './InterestTriGroupSwipeSession';

function InterestSwipeSession(props) {
  const { t } = useTranslation();
  const { loading, isTriGroup } = useInterestSessionModel();

  if (loading) {
    return (
      <div className="rounded-lg border border-edge bg-surface p-6 text-sm text-ink-muted">
        {t('interestTest.loading')}
      </div>
    );
  }

  if (isTriGroup) {
    return <InterestTriGroupSwipeSession {...props} />;
  }

  return <InterestLegacySwipeSession {...props} />;
}

export default InterestSwipeSession;
